import { Flex, Tag, Text } from '@spotify-internal/encore-web';
import { extractLastNameComponent } from '@spotify/confidence-core-react';

import styles from './MetricRow.module.css';

interface MetricRowProps {
  name: string;
  displayName?: string | null;
  role: string;
}

export const MetricRow = ({ name, displayName, role }: MetricRowProps) => {
  const label =
    displayName || extractLastNameComponent(name) || name || 'Unnamed metric';

  return (
    <Flex alignItems="center" gap="tighter-2">
      <Text className={styles.name} variant="bodySmall">
        {label}
      </Text>
      <Tag>{role}</Tag>
    </Flex>
  );
};
